<template>
  <b-card class="d-flex" :class="{ [`root-node`]: isRoot }" @click="toggleFold">
    <div class="d-flex align-items-center">
      <div>
        <b-card-title
          class="d-flex align-items-center"
          :style="{
            minWidth: '20rem',
          }"
        >
          <audio-player :voice="item.voice" />
          <span class="pl-1 d-flex align-items-center">
            <feather-icon
              v-if="!isRoot"
              :class="commandIcons[item.command]"
              size="16"
              :icon="commandIcons[item.command]"
            />
            <span v-else>
              <flag :iso="getCountryCode(language)" :squared="false" />
            </span>
            <span class="pl-1">#{{ item.onKey }}.&nbsp;</span>
            <span>{{ item.memo }}</span>
          </span>
        </b-card-title>
        <b-card-sub-title v-if="!isRoot && !hasChildren">
          <pre class="card-subtitle text-muted">{{ item.description }}</pre>
        </b-card-sub-title>
      </div>
    </div>
    <div class="action-wrapper d-flex align-items-center">
      <b-button-group
        :vertical="!isRoot && !hasChildren && item.command != 'tree'"
      >
        <b-button
          v-if="isRoot || hasChildren || item.command == 'tree'"
          variant="outline-primary"
          size="sm"
          @click="handleCreate"
        >
          {{ $t("button.addCommand") }}
        </b-button>
        <b-button variant="outline-primary" size="sm" @click="handleUpdate">
          {{ $t("button.edit") }}
        </b-button>
        <b-button
          v-if="$can('delete', permissionType)"
          variant="outline-primary"
          size="sm"
          @click="handleDelete"
        >
          {{ $t("button.delete") }}
        </b-button>
      </b-button-group>
      <feather-icon
        v-if="hasChildren"
        class="ChevronRightIcon resposive-icon"
        size="26"
        icon="ChevronRightIcon"
      />
      <div class="wrapper-resposive-icon">
        <feather-icon
          v-if="hasChildren"
          class="ChevronDownIcon d-none resposive-icon"
          size="26"
          icon="ChevronDownIcon"
        />
      </div>
    </div>
    <div class="icon-mobilesite d-none">
      <feather-icon
        v-if="hasChildren"
        class="ChevronRightIcon"
        size="20"
        icon="ChevronDownIcon"
      />
      <feather-icon
        v-if="hasChildren"
        class="ChevronDownIcon d-none"
        size="20"
        icon="ChevronUpIcon"
      />
    </div>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButtonGroup,
  BButton,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BLink,
  BSpinner,
} from "bootstrap-vue";
import localeCountries from "@/data/localeCountries";
import AudioPlayer from "./AudioPlayer.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    BLink,
    BButtonGroup,
    BButton,
    BSpinner,

    AudioPlayer,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    store: {
      type: Object,
      required: true,
    },
    locales: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      commandIcons: {
        tree: "CornerDownRightIcon",
        call: "PhoneCallIcon",
        no: "CheckIcon",
      },
    };
  },
  computed: {
    isRoot() {
      return !!this.item.parent.isRoot;
    },
    hasChildren() {
      return this.item.children && this.countChildren > 0;
    },
    countChildren() {
      return this.item.children.length;
    },
    isVisible() {
      return this.searchVisible(this.item);
    },
    language() {
      return this.locales.find((e) => e.language == this.item.localeCode)
        ?.language;
    },
  },
  mounted() {
    // this.store.toggleOpen(this.item);
  },
  methods: {
    getCountryCode(language) {
      return this.localeCountries.find(
        (e) => e.language.toLowerCase() === language.toLowerCase()
      ).flag;
    },
    searchVisible(item) {
      if (item.visible) {
        const { parent } = item;
        if (parent && !parent.isRoot) {
          return this.searchVisible(parent);
        }
        return true;
      }
      return false;
    },
    toggleFold(event) {
      if (event.target.tagName.toLowerCase() !== "button") {
        this.store.toggleOpen(this.item);
      }
    },
    handleCreate() {
      this.$emit("onCreate", this.item);
    },
    handleUpdate() {
      this.$emit("onUpdate", this.item);
    },
    handleDelete() {
      this.$emit("onDelete", this.item);
    },
  },
  setup() {
    const permissionType = "call-center"; // "modify-quick-message";

    return {
      localeCountries,
      permissionType,
    };
  },
};
</script>

<style scoped lang="scss">
.action-wrapper {
  .btn-group {
    @media (max-width: 600px) {
      display: flex;
      flex-direction: column;
    }

    .btn {
      font-size: 0.8rem;
    }
  }

  .resposive-icon {
    @media (max-width: 600px) {
      display: none;
    }
  }

  .wrapper-resposive-icon {
    @media (max-width: 600px) {
      display: none;
    }
  }
}

.he-tree {
  .icon-mobilesite {
    @media (max-width: 600px) {
      display: block !important;
      position: absolute;
      bottom: 5%;
      right: 50%;
      left: 50%;
    }
  }

  .tree-node {
    .ChevronRightIcon,
    .ChevronDownIcon {
      margin-right: 0.5rem;
    }

    &.open > .tree-node-inner-back {
      .ChevronRightIcon {
        display: none !important;
      }

      .ChevronDownIcon {
        display: block !important;
      }
    }

    .CircleIcon {
      margin-top: 3px;
    }

    .group-icons {
      min-width: 55px;

      @media (max-width: 420px) {
        display: flex;
        align-items: center;
      }

      svg {
        color: #989898;
      }
    }

    .card {
      margin: 0;

      .card-title {
        margin-bottom: 0;
      }

      .card-subtitle {
        margin-top: 0.3rem;
      }

      .card-body {
        display: flex;
        padding: 0 16px;
        margin: 0;
        justify-content: space-between;

        .d-flex {
          padding: 5px 0;
          overflow: hidden;
          max-width: 80%;

          @media (max-width: 425px) {
            max-width: 50%;
          }

          h6 {
            text-overflow: ellipsis;
            overflow: hidden;
            // Addition lines for 2 line or multiline ellipsis
            display: -webkit-box !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
          }

          h4 {
            &.card-title {
              @media (max-width: 420px) {
                align-items: center;
                display: -webkit-box;
                max-width: 200px;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
          }

          @media (max-width: 420px) {
            align-items: center;
          }
        }
      }

      pre {
        background: unset;
      }

      &.root-node {
        margin: 0;
        padding: 8px 0;

        & .card-title {
          margin: 0;
        }
      }

      &:hover {
        background-color: #eee;
      }

      button.btn {
        border: 0 !important;
        outline: unset;
      }
    }

    &.loading-children {
      .node-spinner {
        display: block !important;
        margin-right: 30px;

        & > span {
          width: 1.5rem;
          height: 1.5rem;
          color: #cacaca !important;
        }
      }

      .group-icons {
        display: none;
      }
    }
  }
}
</style>
